'use client';

import { Box, CircularProgress, Typography } from '@mui/material';

import { ErrorState } from '@/components/common/ErrorState';
import { useT } from '@/hooks';

interface WalletLinkStateProps {
  isError: boolean;
  isLinking: boolean;
  onRetry: () => void;
}

export const WalletLinkState = ({ isError, isLinking, onRetry }: WalletLinkStateProps) => {
  const { t } = useT();

  if (isError) {
    return (
      <ErrorState
        title={t('walletLink.failed')}
        message={t('walletLink.failedDesc')}
        onRetry={onRetry}
      />
    );
  }

  if (isLinking) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          py: 8,
          gap: 2,
        }}
      >
        <CircularProgress size={32} thickness={5} />
        <Typography variant="body1" color="text.secondary">
          {t('walletLink.linking')}
        </Typography>
      </Box>
    );
  }

  return null;
};
